import 'assets/css/modal.css';
import 'styles/custom.css';
import * as React from 'react';
import { PrimaryButton, TextField } from 'office-ui-fabric-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { GetGlobalICDConsumptionStatus, GetICDConsumptionStatus, ChangeICDConsumptionStatus, ChangeGlobalICDConsumptionStatus, GetICDFlushStatus, ChangeICDFlushStatus } from "../components/Requests/Requests"
import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';
import { 
  StandardScreen,
  StandardDropdown, 
  StandardTextField, 
  StandardButton, 
  StatusMessage, 
  PageLayout
} from '../components/Layout';

class ICD extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            spHostUrl: "",
            chosenNewStatus: "",
            globalStatus: "",
            clientUrl: "",
            SearchString: "",
            GlobalError: "",
            UpdateError: "",
            GetError: "",
            LoadingGet: false,
            LoadingGetMessage: "",
            LoadingGlobal: false,
            LoadingSubmit: false,
            tableRows: [],
            flushSearchString: "",
            flushSpHostUrl: "",
            flushClientUrl: "",
            flushLimit: "",
            FlushGetError: "",
            FlushUpdateError: "",
            LoadingFlushGet: false,
            LoadingFlushGetMessage: "",
            LoadingFlushSubmit: false,
            flushTableRows: [],
            activeTab: 'consumption'
        }
    }

    componentDidMount() {
        this.initializeSettings();
    }

    initializeSettings() {
        this.GetGlobalConsumptionStatus();
    }

    async GetGlobalConsumptionStatus() {
        this.setState({ LoadingGlobal: true, GlobalError: "" });
        let response = await GetGlobalICDConsumptionStatus(this.props.accessToken);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                LoadingGlobal: false,
                globalStatus: data.status,
            });
        } else {
            let errorMessage = await response.json();
            this.setState({ LoadingGlobal: false, GlobalError: "Something went wrong. " + errorMessage.error });
        };
    }

    async ChangeGlobalConsumptionStatus() {
        this.setState({ LoadingGlobal: true, GlobalError: "" });
        let requestBody = {
            Pause: this.state.globalStatus === "Active"
        };
        let response = await ChangeGlobalICDConsumptionStatus(this.props.accessToken, requestBody);
        if (response.status === 200) {
            this.setState({
                LoadingGlobal: false,
            });
            await this.GetGlobalConsumptionStatus();
        } else if (response.status === 401){
            this.setState({ LoadingGlobal: false, GlobalError: "Only Admins can enable/disable global Consumption" });
        }else {
            let errorMessage = await response.json();
            this.setState({ LoadingGlobal: false, GlobalError: "Something went wrong. " + errorMessage.error });
        };
    }

    async GetConsumptionStatus() {
        this.setState({ LoadingGet: true, LoadingGetMessage: "Fetching Consumption Status", GetError: "" });
        let requestBody = {
            SearchString: this.state.SearchString
        };
        let response = await GetICDConsumptionStatus(this.props.accessToken, requestBody);
        let integrationConsumptionStatus = await response.json();
        if (response.status === 200) {
            if(integrationConsumptionStatus.length === 0)
            {
                this.setState({ GetError: "No entries matching the search string were found."})
            }

            let tableRows = integrationConsumptionStatus.map((consumptionStatus, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{consumptionStatus.spHostUrl}</td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>{consumptionStatus.clientUrl}</td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        {consumptionStatus.status === "Active" ?
                            <span style={{ color: 'green' }}>Active</span> :
                            <span style={{ color: 'red' }}>Paused</span>}
                    </td>
                    <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                            <PrimaryButton
                                text={consumptionStatus.status === "Active" ? "Pause" : "Resume"}
                                style={{ width: '100px' }}
                                onClick={ async () => {
                                    this.setState({ LoadingGet: true, LoadingGetMessage: "Updating Status" });
                                    const error = await this.ChangeConsumptionStatus(consumptionStatus.spHostUrl, consumptionStatus.clientUrl, consumptionStatus.status === "Active");
                                    if (error)
                                    {
                                        this.setState({ GetError: error, LoadingGet: false });
                                    }
                                    else
                                    {
                                        this.setState({ LoadingGetMessage: "Fetching Consumption Status" });
                                        this.GetConsumptionStatus();
                                    }
                                }}
                                iconProps={consumptionStatus.status === "Active" ? { iconName: 'Pause' } : { iconName: 'Play' }}/>
                    </td>
                </tr>
            ));
            this.setState({ LoadingGet: false, tableRows: tableRows });
        } else {
            this.setState({ LoadingGet: false, GetError: "Something went wrong" });
        };
    }

    async ChangeConsumptionStatus(spHostUrl, clientUrl, pause){
        let requestBody = {
            spHostUrl: spHostUrl,
            clientUrl: clientUrl,
            pause: pause,
        };
        let response = "";
        response = await ChangeICDConsumptionStatus(this.props.accessToken, requestBody);
        if (response.status === 200) {
            return;
        } else {
            let errorMessage = await response.json();
            return "Something went wrong. " + errorMessage.error;
        }
    }

    async GetFlushStatus() {
        this.setState({ LoadingFlushGet: true, LoadingFlushGetMessage: "Fetching Flush Status", FlushGetError: "" });
        let requestBody = {
            SearchString: this.state.flushSearchString
        };
        let response = await GetICDFlushStatus(this.props.accessToken, requestBody);
        let flushStatuses = await response.json();
        if (response.status === 200) {
            if(flushStatuses.length === 0)
            {
                this.setState({ FlushGetError: "No entries matching the search string were found."})
            }

            this.setState({ LoadingFlushGet: false, flushTableRows: this.renderFlushTableRows(flushStatuses) });
        } else {
            this.setState({ LoadingFlushGet: false, FlushGetError: "Something went wrong" });
        };
    }

    renderFlushTableRows(flushStatuses) {
        return flushStatuses.map((flushStatus, index) => (
            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{flushStatus.spHostUrl}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{flushStatus.clientUrl}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                    {flushStatus.status === "Active" ?
                        <span style={{ color: 'orange' }}>Active</span> :
                        <span style={{ color: 'green' }}>Inactive</span>}
                </td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{flushStatus.flushLimit ?? "Unlimited"}</td>
                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                        <PrimaryButton
                            text={flushStatus.status === "Active" ? "Deactivate" : "Activate"}
                            style={{ width: '120px' }}
                            onClick={ async () => {
                                this.setState({ LoadingFlushGet: true, LoadingFlushGetMessage: "Updating Flush Status" });
                                const error = await this.ChangeFlushStatus(flushStatus.spHostUrl, flushStatus.clientUrl, flushStatus.status !== "Active");
                                if (error)
                                {
                                    this.setState({ FlushGetError: error, LoadingFlushGet: false });
                                }
                                else
                                {
                                    this.setState({ LoadingFlushGetMessage: "Fetching Flush Status" });
                                    this.GetFlushStatus();
                                }
                            }}
                            iconProps={flushStatus.status === "Active" ? { iconName: 'Delete' } : { iconName: 'Play' }}/>
                </td>
            </tr>
        ));
    }

    async ChangeFlushStatus(spHostUrl, clientUrl, active, flushLimit){
        let requestBody = {
            spHostUrl: spHostUrl,
            clientUrl: clientUrl,
            active: active,
        };
        if (flushLimit && isNaN(parseInt(flushLimit))) {
            return "Flush limit must be a valid number";
        }
        if (flushLimit) {
            requestBody.flushLimit = parseInt(flushLimit);
        }
        let response = await ChangeICDFlushStatus(this.props.accessToken, requestBody);
        if (response.status === 200) {
            return;
        } else {
            let errorMessage = await response.json();
            return "Something went wrong. " + errorMessage.error;
        }
    }

    onSearchStringChange = (event, newValue) => {
        this.setState({ 
            SearchString: newValue,
            GetError: "",
            tableRows: []
        });
    };

    onClientUrlChange = (event, newValue) => {
        this.setState({ 
            clientUrl: newValue,
            UpdateError: ""
        });
    };

    onSpHostUrlChange = (event, newValue) => {
        this.setState({ 
            spHostUrl: newValue,
            UpdateError: ""
        });
    };

    onStatusChange = (event, item) => {
        this.setState({ 
            chosenNewStatus: item.key,
            UpdateError: ""
        });
    };

    onFlushSearchStringChange = (event, newValue) => {
        this.setState({ 
            flushSearchString: newValue,
            FlushGetError: "",
            flushTableRows: []
        });
    };

    onFlushClientUrlChange = (event, newValue) => {
        this.setState({ 
            flushClientUrl: newValue,
            FlushUpdateError: ""
        });
    };

    onFlushSpHostUrlChange = (event, newValue) => {
        this.setState({ 
            flushSpHostUrl: newValue,
            FlushUpdateError: ""
        });
    };

    onFlushLimitChange = (event, newValue) => {
        this.setState({ 
            flushLimit: newValue,
            FlushUpdateError: ""
        });
    };

    render() {
        const {
            LoadingGlobal,
            LoadingGet,
            LoadingSubmit,
            LoadingGetMessage,
            globalStatus,
            SearchString,
            clientUrl,
            spHostUrl,
            chosenNewStatus,
            GlobalError,
            GetError,
            UpdateError,
            tableRows,
            flushSearchString,
            flushSpHostUrl,
            flushClientUrl,
            flushLimit,
            FlushGetError,
            FlushUpdateError,
            LoadingFlushGet,
            LoadingFlushGetMessage,
            LoadingFlushSubmit,
            flushTableRows,
            activeTab
        } = this.state;

        const statusOptions = [
            { key: 'Pause', text: 'Pause' },
            { key: 'Resume', text: 'Resume' }
        ];

        return (
            <PageLayout>
                <Pivot
                    selectedKey={activeTab}
                    onLinkClick={(item) => this.setState({ activeTab: item.props.itemKey })}
                    styles={{
                        root: { marginBottom: '10px', minWidth: '600px', maxWidth: 'calc(100vw - 320px)' },
                        link: { fontSize: '16px' },
                        linkIsSelected: { fontSize: '16px' }
                    }}
                >
                    <PivotItem headerText="Consumption Status" itemKey="consumption">
                        <StandardScreen
                            title="Global ICD Consumption Status"
                            description="Manage Global consumption. Pausing this will disable ICD for all customers."
                        >
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <label style={{ width: '100px', marginRight: '10px', fontSize: '1.1em', fontWeight: 'bold' }}>
                                    {LoadingGlobal ?
                                        <Spinner size={SpinnerSize.medium} /> :
                                        (globalStatus === "Paused" ?
                                            <span style={{ color: 'red' }}>Paused</span> :
                                            <span style={{ color: 'green' }}>Active</span>
                                        )
                                    }
                                </label>
                                <StandardButton
                                    text='Refresh'
                                    onClick={() => this.GetGlobalConsumptionStatus()}
                                    disabled={LoadingGlobal}
                                    style={{ marginRight: '10px' }}
                                />
                                <StandardButton
                                    text={globalStatus === "Paused" ? "Resume" : "Pause"}
                                    onClick={() => this.ChangeGlobalConsumptionStatus()}
                                    disabled={LoadingGlobal}
                                />
                            </div>

                            {GlobalError && (
                                <StatusMessage type="error">{GlobalError}</StatusMessage>
                            )}
                        </StandardScreen>

                        <StandardScreen
                            title="Get Consumption Status"
                            description="Get consumption status for integrations based on a search string. The search string should be a component of one of the associated URLs. If left empty the status of all integrations will be displayed. If an integration cannot be found it does not have a status yet and it is therefore active."
                        >
                            <StandardTextField
                                label="Query"
                                placeholder="Text to search for"
                                value={SearchString}
                                onChange={this.onSearchStringChange}
                            />

                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                <StandardButton
                                    text='Search'
                                    onClick={() => this.GetConsumptionStatus()}
                                    disabled={LoadingGet}
                                    style={{ marginRight: '10px' }}
                                />
                                {LoadingGet && (
                                    <Spinner size={SpinnerSize.small} label={LoadingGetMessage} />
                                )}
                            </div>

                            {GetError && (
                                <StatusMessage type="error">{GetError}</StatusMessage>
                            )}

                            {!LoadingGet && tableRows && tableRows.length > 0 && (
                                <div style={{ marginTop: '20px' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#f2f2f2' }}>
                                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>SharePoint URL</th>
                                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>DealCloud URL</th>
                                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Status</th>
                                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Update</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableRows}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </StandardScreen>

                        <StandardScreen
                            title="Update Consumption Status"
                            description="Add/Update status for a particular customer based on their SharePoint Host URL and DealCloud Client URL."
                        >
                            <StandardTextField
                                label="DealCloud URL"
                                placeholder=" DealCloud Client URL"
                                value={clientUrl}
                                onChange={this.onClientUrlChange}
                            />

                            <StandardTextField
                                label="SharePoint URL"
                                placeholder="SharePoint Site URL"
                                value={spHostUrl}
                                onChange={this.onSpHostUrlChange}
                            />

                            <StandardDropdown
                                label="Status"
                                selectedKey={chosenNewStatus}
                                onChange={this.onStatusChange}
                                placeholder="New Status"
                                options={statusOptions}
                            />

                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                <StandardButton
                                    text='Submit'
                                    onClick={async () => {
                                        this.setState({ LoadingSubmit: true, UpdateError: "" });
                                        const error = await this.ChangeConsumptionStatus(spHostUrl, clientUrl, chosenNewStatus === "Pause");
                                        if (error)
                                        {
                                            this.setState({ UpdateError: error });
                                        }
                                        this.setState({ LoadingSubmit: false });
                                    }}
                                    disabled={LoadingSubmit || !spHostUrl || !clientUrl || !chosenNewStatus}
                                    style={{ marginRight: '10px' }}
                                />
                                {LoadingSubmit && (
                                    <Spinner size={SpinnerSize.small} label="Updating..." />
                                )}
                            </div>

                            {UpdateError && (
                                <StatusMessage type="error">{UpdateError}</StatusMessage>
                            )}
                        </StandardScreen>
                    </PivotItem>

                    <PivotItem headerText="Flush Status" itemKey="flush">
                        <StandardScreen
                            title="Get Flush Status"
                            description="Get flush status for integrations based on a search string. The search string should be a component of the SharePoint Host URL. If an integration cannot be found it does not have a flush configured and is therefore consuming normally."
                        >
                            <StandardTextField
                                label="Query"
                                placeholder="SPHostUrl to search for"
                                value={flushSearchString}
                                onChange={this.onFlushSearchStringChange}
                            />

                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                <StandardButton
                                    text='Search'
                                    onClick={() => this.GetFlushStatus()}
                                    disabled={LoadingFlushGet}
                                    style={{ marginRight: '10px' }}
                                />
                                {LoadingFlushGet && (
                                    <Spinner size={SpinnerSize.small} label={LoadingFlushGetMessage} />
                                )}
                            </div>

                            {FlushGetError && (
                                <StatusMessage type="error">{FlushGetError}</StatusMessage>
                            )}

                            {!LoadingFlushGet && flushTableRows && flushTableRows.length > 0 && (
                                <div style={{ marginTop: '20px' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#f2f2f2' }}>
                                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>SharePoint URL</th>
                                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>DealCloud URL</th>
                                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Status</th>
                                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Flush Limit</th>
                                                <th style={{ border: '1px solid #ddd', padding: '8px' }}>Update</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {flushTableRows}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </StandardScreen>

                        <StandardScreen
                            title="Update Flush Status"
                            description="Add/Update flush status for a particular customer based on their SharePoint Host URL and DealCloud Client URL. Activating a flush will cause messages on the Kafka topic to be discarded until the flush limit is reached or the flush is manually deactivated. Only use this to clear bad data from the topic."
                        >
                            <StandardTextField
                                label="DealCloud URL"
                                placeholder="DealCloud Client URL"
                                value={flushClientUrl}
                                onChange={this.onFlushClientUrlChange}
                            />

                            <StandardTextField
                                label="SharePoint URL"
                                placeholder="SharePoint Site URL"
                                value={flushSpHostUrl}
                                onChange={this.onFlushSpHostUrlChange}
                            />

                            <StandardTextField
                                label="Flush Limit (Optional)"
                                placeholder="Number of messages to flush (leave empty for unlimited)"
                                value={flushLimit}
                                onChange={this.onFlushLimitChange}
                                type="number"
                            />

                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                <StandardButton
                                    text='Activate Flush'
                                    onClick={async () => {
                                        this.setState({ LoadingFlushSubmit: true, FlushUpdateError: "" });
                                        const error = await this.ChangeFlushStatus(flushSpHostUrl, flushClientUrl, true, flushLimit);
                                        if (error)
                                        {
                                            this.setState({ FlushUpdateError: error });
                                        }
                                        this.setState({ LoadingFlushSubmit: false });
                                    }}
                                    disabled={LoadingFlushSubmit || !flushSpHostUrl || !flushClientUrl}
                                    style={{ marginRight: '10px' }}
                                />
                                <StandardButton
                                    text='Deactivate Flush'
                                    onClick={async () => {
                                        this.setState({ LoadingFlushSubmit: true, FlushUpdateError: "" });
                                        const error = await this.ChangeFlushStatus(flushSpHostUrl, flushClientUrl, false);
                                        if (error)
                                        {
                                            this.setState({ FlushUpdateError: error });
                                        }
                                        this.setState({ LoadingFlushSubmit: false });
                                    }}
                                    disabled={LoadingFlushSubmit || !flushSpHostUrl || !flushClientUrl}
                                    style={{ marginRight: '10px' }}
                                />
                                {LoadingFlushSubmit && (
                                    <Spinner size={SpinnerSize.small} label="Updating flush status..." />
                                )}
                            </div>

                            {FlushUpdateError && (
                                <StatusMessage type="error">{FlushUpdateError}</StatusMessage>
                            )}
                        </StandardScreen>
                    </PivotItem>
                </Pivot>
            </PageLayout>
        );
    }
}

export default ICD;